import PropTypes from "prop-types";
import React, { Component } from "react";
import logo from "static/images/logo.png";
import {MSpinner} from "components/Shared";

class LoginSso extends Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      isHandlingToken: false
    };

    this.ssoUserLogin = this.ssoUserLogin.bind(this);
  }

  componentDidMount() {
    // Get SSO token from query param (new approach) or path param (legacy)
    const searchParams = new URLSearchParams(window.location.search);
    const ssoToken = searchParams.get('token') || this.props.match?.params?.SSO;
    if (!this.state.isHandlingToken && ssoToken){
      this.ssoUserLogin(ssoToken);
    }
  }

  ssoUserLogin(ssoToken){
    this.setState({
      isHandlingToken: true,
      isFetching: true
    });
    this.props.userLogin({
      sso: ssoToken
    });
  }

  render() {
    return (
      <div className="md-grid md-cell login-wrapper">
        <div className="login-form">
          <img src={logo} alt="logo.png" className="mueller-logo" />
          <h3 className="mueller-title" data-test="title" title="Authenticating login">Validating Credentials</h3>
          <MSpinner/>
        </div>
      </div>
    );
  }

}

LoginSso.propTypes = {
  userLogin: PropTypes.func.isRequired,
  match: PropTypes.object,
  SSO: PropTypes.string
};

export default LoginSso;
